import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api';
import useBreakpoint from '~/composables/useBreakpoint';
import { getAssetUrl } from '~/composables/useMediaAsset';
import handleImageAlt from '~/helpers/handleImageAlt';
import handleImageSrc from '~/helpers/handleImageSrc';
import { CdnImg } from '@webplatform/cdn-image';


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryBanner',
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const markersBoardImageStyles = computed(() => {
  const styles = props.data.markersBoard?.styles;
  return isDesktop.value ? styles?.desktop : styles.mobile;
});

return { __sfc: true,props, isDesktop, markersBoardImageStyles, getAssetUrl, handleImageAlt, handleImageSrc, CdnImg }
}

})